import {
  LOADING_PEOPLE,
  LOAD_PEOPLE,
  FETCH_PEOPLE_REQUEST,
  FETCH_PEOPLE_REQUEST_SUCCESS,
  PEOPLE_SAVE_REQUEST,
  PEOPLE_SAVE_SUCCESS,
  PROFILE_SAVE_REQUEST,
  PROFILE_SAVE_SUCCESS,
  PROFILE_AVATAR_SAVE_SUCCESS,
  PROFILE_AVATAR_SAVE_REQUEST,
  PEOPLE_EMPLOYEE_FACILITIES,
  FETCH_PEOPLE_ROOT_FACILITY_REQUEST_SUCCESS,
  FETCH_PEOPLE_ROOT_FACILITY_REQUEST,
  PROFILE_SAVE_SUCCESS_FAILED,
  SEND_MAIL,
  SEND_MAIL_SUCCESS,
} from "../types/people.types";
import { ICompany } from "./company.reducer";

export interface IPeople {
  id: string;
  guid: string;
  fullname: string;
  username: string;
  address: string;
  mobile_number: string;
  date_of_birth: string;
  is_superuser: boolean;
  is_active: boolean;
  is_staff: boolean;
  user_role: string;
  avatar: string;
  visa_type?: string;
  timesheet_limit_warn?: number;
}

export type peopleStateType = {
  users: null | IPeople[];
  user: null | IPeople;
  total: number;
  current: number;
  loading: boolean;
  save: boolean;
  avatar: null | any;
  avatarSave: boolean;
  facilities: ICompany[];
  facility: null | ICompany;
  sendMailLoading: boolean;
  sendMail: boolean;
};

const initialState = {
  users: null,
  user: null,
  total: 0,
  current: 1,
  loading: false,
  save: false,
  avatar: null,
  avatarSave: false,
  facilities: [],
  facility: null,
  sendMailLoading: false,
  sendMail: false,
};

export default function peopleReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_PEOPLE:
      return {
        loading: false,
        users: action.payload.results,
        total: action.payload.count,
        current: action.payload.current,
      };
    case LOADING_PEOPLE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PEOPLE_REQUEST:
      return {
        ...state,
        user: null,
        loading: true,
      };
    case FETCH_PEOPLE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case PEOPLE_SAVE_REQUEST:
    case PROFILE_SAVE_SUCCESS_FAILED:
      return {
        ...state,
        save: false,
      };
    case PEOPLE_SAVE_SUCCESS:
      return {
        ...state,
        save: true,
        user: null,
      };
    case PROFILE_SAVE_REQUEST:
      return {
        ...state,
        save: true,
      };
    case PROFILE_SAVE_SUCCESS:
      return {
        ...state,
        save: false,
        user: action.payload,
      };

    case PROFILE_AVATAR_SAVE_REQUEST:
      return {
        ...state,
        avatarSave: true,
      };
    case PROFILE_AVATAR_SAVE_SUCCESS:
      return {
        ...state,
        avatarSave: false,
        avatar: action.payload,
      };
    case PEOPLE_EMPLOYEE_FACILITIES:
      return {
        ...state,
        facilities: action.payload,
      };
    case FETCH_PEOPLE_ROOT_FACILITY_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_PEOPLE_ROOT_FACILITY_REQUEST_SUCCESS:
      return {
        ...state,
        facility: action.payload,
        loading: false,
      };
    case SEND_MAIL:
      return {
        ...state,
        sendMail: false,
        sendMailLoading: true,
      };
    case SEND_MAIL_SUCCESS:
      return {
        ...state,
        sendMail: true,
        sendMailLoading: false,
      };
    default:
      return state;
  }
}
